import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { storage } from "@/modules/storage";

const useHistory = () => {
  const location = useLocation();

  const [routeBackNumber, setRouteBackNumber] = useState(
    parseInt(storage.getItem("routeBackNumber") || "-1"),
  );

  useEffect(() => {
    if (location.pathname && location.search) {
      const currentLocation = location.pathname + location.search;

      setTimeout(() => {
        if (storage.getItem("currentLocation") !== currentLocation) {
          setRouteBackNumber((prevRouteBackNumber) => prevRouteBackNumber - 1);
          storage.setItem("currentLocation", currentLocation);
        }
      }, 10);
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    storage.setItem("routeBackNumber", routeBackNumber.toString());
  }, [routeBackNumber]);
  useEffect(() => {
    const currentLocation = location.pathname + location.search;
    if (storage.getItem("currentLocation") === currentLocation) {
      return;
    }
    return () => {
      storage.removeItem("currentLocation");
      storage.removeItem("routeBackNumber");
    };
  }, [location.pathname, location.search]);
  return {
    routeBackNumber,
    setRouteBackNumber,
  };
};

export default useHistory;
